// import Components from "./components";
import Services from "./services";
// import ChartIQModuleConfig from "./ChartIQModuleConfig";

export default angular.module("tfApp.components.chartiq", [Services])
                      .name;
